import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from 'react';
// 1. Convert all components to lazy imports
var AdminDashboard = lazy(function () { return import("@pages/common/dashboard/AdminDashboard"); });
var MessageStatistics = lazy(function () { return import("@pages/admin/MessageStatistics"); });
var MandantList = lazy(function () { return import("@pages/mandant/MandantList"); });
var MandantNew = lazy(function () { return import("@pages/mandant/MandantNew"); });
var UserDBList = lazy(function () { return import("@pages/user/UserList"); });
var UserNew = lazy(function () { return import("@pages/user/UserNew"); });
var NonStampableItemsNew = lazy(function () { return import("@pages/admin/NonStampableItemsNew"); });
var DeclarationStatistics = lazy(function () { return import("@pages/admin/DeclarationStatistics"); });
export var adminRoutes = [
    {
        path: "dashboard",
        element: _jsx(AdminDashboard, {})
    },
    {
        path: "client",
        element: _jsx(MandantList, {})
    },
    {
        path: "client/new",
        element: _jsx(MandantNew, {})
    },
    {
        path: "client/user/list",
        element: _jsx(UserDBList, {})
    },
    {
        path: "client/user/new",
        element: _jsx(UserNew, {})
    },
    {
        path: "message-statistics",
        element: _jsx(MessageStatistics, {})
    },
    {
        path: "nonstampableitems/new",
        element: _jsx(NonStampableItemsNew, {})
    },
    {
        path: "declaration-statistics",
        element: _jsx(DeclarationStatistics, {})
    }
];
